// extracted by mini-css-extract-plugin
export default {"button":"SimpleButton_button__tkcTo","submit":"SimpleButton_submit__e+iwy","critical":"SimpleButton_critical__6PxGy","disabled":"SimpleButton_disabled__PQSaP"};